import { connectFela } from '../../dependencies';
import DeleteMembershipModal from './DeleteMembershipModal';
import * as styles from './DeleteMembershipModal.styles';

export default connectFela(styles)(DeleteMembershipModal);
